var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_413_11456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 -0.15C9.08683 -0.15 -0.15 9.08578 -0.15 20.5C-0.15 31.913 9.08578 41.15 20.5 41.15C31.9132 41.15 41.15 31.9142 41.15 20.5C41.15 9.08699 31.9142 -0.15 20.5 -0.15ZM20.5 37.9895C10.8564 37.9895 3.01047 30.1437 3.01047 20.5C3.01047 10.8563 10.8564 3.01047 20.5 3.01047C30.1436 3.01047 37.9895 10.8563 37.9895 20.5C37.9895 30.1437 30.1436 37.9895 20.5 37.9895Z",
    fill: "#AE8FD6",
    stroke: "#AE8FD6",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.572 18.3567C18.572 18.0448 18.7477 17.7707 19.0832 17.5675C19.421 17.363 19.9114 17.2384 20.4997 17.2384C21.0601 17.2384 21.5586 17.3625 21.9116 17.5687C22.2645 17.7749 22.4544 18.05 22.4544 18.3566V28.6376C22.4544 28.8875 22.2679 29.1714 21.9066 29.4016C21.5512 29.6281 21.0533 29.7828 20.4997 29.7828C19.9182 29.7828 19.4283 29.6276 19.0882 29.4029C18.7444 29.1759 18.572 28.8926 18.572 28.6376V18.3567ZM18.4371 12.6629C18.4371 11.7376 19.3229 10.8971 20.4997 10.8971C21.6482 10.8971 22.5356 11.7365 22.5356 12.6629C22.5356 13.592 21.6455 14.4559 20.4997 14.4559C19.3259 14.4559 18.4371 13.5909 18.4371 12.6629Z",
    fill: "#AE8FD6",
    stroke: "#AE8FD6",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_413_11456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.7f16007e6f575692cad2e469d5c35bc0.svg";
export { ForwardRef as ReactComponent };